<template>
  <div class="login">
    <div class="login_con_top wjmm_con_top"></div>
    <div class="login_con" v-loading="qyloading">
      <div class="m-login-panel">
        <el-form ref="dataForm" :rules="rules" :model="formData">
          <div class="login_con_pub">
            <div class="login_con_pub_info login_con_pub_phone clearfix">
              <el-form-item prop='tel'>
                <el-input v-model="formData.tel" placeholder="请输入手机号码" class="wjinput" maxlength="11"></el-input>
              </el-form-item>
              <a href="javascript:;" v-show="codeType" @click="sendCode" class="wjinput">发送手机验证码</a>
              <a href="javascript:;" v-show="!codeType" class="wjinput">{{ count }}s</a>
            </div>
          </div>
          <div class="login_con_pub">
            <div class="login_con_pub_info login_con_pub_yzm">
              <el-form-item prop='code'>
                <el-input v-model="formData.code" placeholder="手机验证码" class="wjinput"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="login_con_pub">
            <div class="login_con_pub_info login_con_pub_pass">
              <el-form-item prop='password'>
                <el-input v-model="formData.password" placeholder="请输入您的新密码" show-password class="wjinput"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="login_con_pub">
            <div class="login_con_pub_info login_con_pub_pass">
              <el-form-item prop='confirmpassword'>
                <el-input v-model="formData.confirmpassword" placeholder="请确认密码" show-password class="wjinput"></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="reg_con_pub clearfix">
            <div class="if_have"><router-link :to="{path:'/Login'}">返回登录</router-link></div>
          </div>
          <a class="login_con_loginbtn login_con_regbtn" href="javascript:;" @click="subPass">
            确&emsp;&emsp;认
          </a>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { findPass, sendSMS } from '@/api/login'

export default {
  name: 'Forget',
  data () {
    let validateConfirmPassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value !== this.formData.password) {
        callback(new Error('两次密码输入不一致'))
      } else {
        callback()
      }
    }
    let checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('手机号不能为空'))
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
        if (reg.test(value)) {
          callback()
        } else {
          return callback(new Error('请输入正确的手机号'))
        }
      }
    }
    return {
      formData: {
        tel: '',
        code: '',
        password: ''
      },
      codeType: true,
      count: '',
      timer: null,
      rules: {
        tel: [{ validator: checkPhone, trigger: 'blur' }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        code: [{ required: true, message: '请输入手机验证码', trigger: 'blur' }],
        confirmpassword: [{ required: true, validator: validateConfirmPassword, trigger: 'blur' }]
      }
    }
  },
  methods: {
    subPass () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          findPass(this.formData).then(res => {
            this.$router.push({ path: '/' })
          })
        }
      })
    },
    sendCode () {
      const regs = /^1[3|4|5|7|8][0-9]\d{8}$/
      if (!this.formData.tel || !regs.test(this.formData.tel)) {
        this.$message.error('请输入正确的手机号码')
        return false
      }
      sendSMS({tel: this.formData.tel}).then(res => {
        console.info(res)
      })
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.codeType = false
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
          } else {
            this.codeType = true
            clearInterval(this.timer)
            this.timer = null
          }
        }, 1000)
      }
    }
  }
}
</script>
<style scoped>
.wjinput{
  font-size: 12px;
}
.m-login-panel{
  overflow: hidden;
  margin-left: 40px;
  padding: 30px 25px;
  background-color: #fff;
  border-radius: 8px;
  position: relative;
  width: 300px;
  min-height: 340px;
  border: 1px solid #eceded;
  box-shadow: 10px 10px 12px 0px rgb(0 55 156 / 15%);
}
  .el-form-item >>> .el-form-item__content{
    line-height: 2px;
  }
  .reg_con_pub .login_con_pub{
    height: 40px;
  }
  .login_con_pub_info.login_con_pub_phone{
    height: 40px;
  }
  .el-form-item{
    height: 40px;
  }
  .login_con_pub{
    height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/view/login/wjmm.vue